import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { Polygon, PolygonProps } from 'react-leaflet';
import { ISegmentationPolygonProps } from '../SegmentationLayerFeatures';

interface IProps {
  isActive: boolean;
}

export const PolygonFeature = observer((props: ISegmentationPolygonProps & PolygonProps & IProps): ReactElement => {
  const handleRef = (element: Polygon<ISegmentationPolygonProps & PolygonProps>): void => {
    if (props.isActive && element && 'enableEdit' in element.leafletElement && typeof element.leafletElement.enableEdit === 'function') {
      element.leafletElement.enableEdit();
    }
  };

  return (
    <Polygon<ISegmentationPolygonProps & PolygonProps>
      {...props}
      ref={handleRef}
    />
  );
});
